module.exports = __webpack_public_path__ + "img/approve.311b98c0.svg";